import vorSteuernData from '../data/01-Einkommensanteile_vor_Steuern-Top_0.1.json';
import nachSteuernData from '../data/10-Einkommenanteile_nach_Steuern-Top_0.1.json';
import umverteilungData from '../data/17-Umverteilung-Top_0.1.json';
import steueranteileData from '../data/24-Steueranteile-Top_0.1.json';
import nominalNachSteuernData from '../data/40-Einkommenschwelle_nach_Steuern_nominal-Top_0.1.json';
import realNachSteuernData from '../data/45-Einkommenschwelle_nach_Steuern_real-Top_0.1.json';
import nominalVorSteuernData from '../data/30-Einkommenschwelle_vor_Steuern_nominal-Top_0.1.json';
import realVorSteuernData from '../data/35-Einkommenschwelle_vor_Steuern_real-Top_0.1.json';

import vorSteuernData1 from '../data/02-Einkommensanteile_vor_Steuern-Top_1.json';
import nachSteuernData1 from '../data/09-Einkommenanteile_nach_Steuern-Top_1.json';
import umverteilungData1 from '../data/16-Umverteilung-Top1.json';
import steueranteileData1 from '../data/22-Steueranteile-Top_1.json';
import nominalNachSteuernData1 from '../data/39-Einkommenschwelle_nach_Steuern_nominal-Top_1.json';
import realNachSteuernData1 from '../data/44-Einkommenschwelle_nach_Steuern_real-Top_1.json';
import nominalVorSteuernData1 from '../data/29-Einkommenschwelle_vor_Steuern_nominal-Top_1.json';
import realVorSteuernData1 from '../data/34-Einkommenschwelle_vor_Steuern_real-Top_1.json';

import vorSteuernData5 from '../data/03-Einkommensanteile_vor_Steuern-Top_5.json';
import nachSteuernData5 from '../data/08-Einkommenanteile_nach_Steuern-Top_5.json';
import umverteilungData5 from '../data/15-Umverteilung-Top_5.json';
import steueranteileData5 from '../data/20-Steueranteile-Top_5.json';
import nominalNachSteuernData5 from '../data/38-Einkommenschwelle_nach_Steuern_nominal-Top_5.json';
import realNachSteuernData5 from '../data/43-Einkommenschwelle_nach_Steuern_real-Top_5.json';
import nominalVorSteuernData5 from '../data/28-Einkommenschwelle_vor_Steuern_nominal-Top_5.json';
import realVorSteuernData5 from '../data/33-Einkommenschwelle_vor_Steuern_real-Top_5.json';

import vorSteuernData20 from '../data/05-Einkommensanteile_vor_Steuern-Top_20.json';
import nachSteuernData20 from '../data/06-Einkommenanteile_nach_Steuern-Top_20.json';
import umverteilungData20 from '../data/12-Umverteilung-Top_20.json';
import steueranteileData20 from '../data/18-Steueranteile-Top_20.json';
import nominalNachSteuernData20 from '../data/36-Einkommenschwelle_nach_Steuern_nominal-Top_20.json';
import realNachSteuernData20 from '../data/41-Einkommenschwelle_nach_Steuern_real-Top_20.json';
import nominalVorSteuernData20 from '../data/26-Einkommenschwelle_vor_Steuern_nominal-Top_20.json';
import realVorSteuernData20 from '../data/31-Einkommenschwelle_vor_Steuern_real-Top_20.json';

import vorSteuernData10 from '../data/04-Einkommensanteile_vor_Steuern-Top_10.json';
import nachSteuernData10 from '../data/07-Einkommenanteile_nach_Steuern-Top_10.json';
import umverteilungData10 from '../data/13-Umverteilung-Top_10.json';
import steueranteileData10 from '../data/19-Steueranteile-Top_10.json';
import nominalNachSteuernData10 from '../data/37-Einkommenschwelle_nach_Steuern_nominal-Top_10.json';
import realNachSteuernData10 from '../data/42-Einkommenschwelle_nach_Steuern_real-Top_10.json';
import nominalVorSteuernData10 from '../data/27-Einkommenschwelle_vor_Steuern_nominal-Top_10.json';
import realVorSteuernData10 from '../data/32-Einkommenschwelle_vor_Steuern_real-Top_10.json';

import anteilSteuernullerKantone from '../data/25-Steuernuller.json';

import React from 'react';

export enum DataCode {
  vorSteuern,
  nachSteuern,
  umverteilung,
  steueranteile,
  realVorSteuern,
  realNachSteuern,
  nominalVorSteuern,
  nominalNachSteuern,
  anteilSteuernuller,
}

export interface Localization {
  index: number;
  code: string;
  name: string;
}

export interface Dataset {
  code: string;
  name: string;
}

export interface DataFile {
  columns: string[];
  column_labels: string[];
  data: {
    year: number;
    data: (number | null)[];
  }[];
}

const stringFormat = (str: string, ...args: string[]) => str.replace(/{(\d+)}/g, (match, index) => args[index] || '');

const colors = [
  { code: 'CH', color: '#ED1D25' },
  { code: 'AG', color: '#00A6B9' },
  { code: 'AI', color: '#700000' },
  { code: 'AR', color: '#BC0000' },
  { code: 'BE', color: '#FF5C01' },
  { code: 'BL', color: '#8E007F' },
  { code: 'BS', color: '#828282' },
  { code: 'FR', color: '#213AAB' },
  { code: 'GE', color: '#FDBF6F' },
  { code: 'GL', color: '#FFE24E' },
  { code: 'GR', color: '#BC5F44' },
  { code: 'JU', color: '#CAB2D6' },
  { code: 'LU', color: '#A6CEE3' },
  { code: 'NE', color: '#34572C' },
  { code: 'NW', color: '#FFB1D5' },
  { code: 'OW', color: '#FF007F' },
  { code: 'SG', color: '#33A02C' },
  { code: 'SH', color: '#FFFF9C' },
  { code: 'SO', color: '#EBCCCB' },
  { code: 'SZ', color: '#F57A80' },
  { code: 'TG', color: '#B2DF8A' },
  { code: 'TI', color: '#6A3D9A' },
  { code: 'UR', color: '#FF9400' },
  { code: 'VD', color: '#02d406' },
  { code: 'VS', color: '#CB2A7B' },
  { code: 'ZG', color: '#5FDAEB' },
  { code: 'ZH', color: '#008BFF' },
];

const getDatasets = (): Array<Dataset> => {
  return [
    {
      code: '20',
      name: '20%',
    },
    {
      code: '10',
      name: '10%',
    },
    {
      code: '5',
      name: '5%',
    },
    {
      code: '1',
      name: '1%',
    },
    {
      code: '0.1',
      name: '0.1%',
    },
  ];
};

const getDataCodeName = (value: DataCode) => {
  switch (value) {
    case DataCode.nachSteuern:
    case DataCode.realNachSteuern:
    case DataCode.nominalNachSteuern:
      return 'nach Steuern';
    case DataCode.steueranteile:
    case DataCode.anteilSteuernuller:
      return 'Steueranteile';
    case DataCode.umverteilung:
      return 'Umverteilung';
    case DataCode.vorSteuern:
    case DataCode.realVorSteuern:
    case DataCode.nominalVorSteuern:
      return 'vor Steuern';
  }
};

const getColor = (code: string) => {
  const colorItem = colors.find((c) => c.code.toLowerCase() === code.toLowerCase());
  if (!colorItem) {
    return '';
  }

  return colorItem.color;
};

const getData = (dataset: Dataset, dataCode: DataCode) => {
  switch (dataCode) {
    case DataCode.nachSteuern:
      switch (dataset.code) {
        case '20':
          return nachSteuernData20;
        case '10':
          return nachSteuernData10;
        case '5':
          return nachSteuernData5;
        case '1':
          return nachSteuernData1;
        case '0.1':
          return nachSteuernData;
      }
      return nachSteuernData; // ToDo :: remove
    case DataCode.vorSteuern:
      switch (dataset.code) {
        case '20':
          return vorSteuernData20;
        case '10':
          return vorSteuernData10;
        case '5':
          return vorSteuernData5;
        case '1':
          return vorSteuernData1;
        case '0.1':
          return vorSteuernData;
      }
      return vorSteuernData; // ToDo :: remove
    case DataCode.umverteilung:
      switch (dataset.code) {
        case '20':
          return umverteilungData20;
        case '10':
          return umverteilungData10;
        case '5':
          return umverteilungData5;
        case '1':
          return umverteilungData1;
        case '0.1':
          return umverteilungData;
      }
      return umverteilungData; // ToDo :: remove
    case DataCode.steueranteile:
      switch (dataset.code) {
        case '20':
          return steueranteileData20;
        case '10':
          return steueranteileData10;
        case '5':
          return steueranteileData5;
        case '1':
          return steueranteileData1;
        case '0.1':
          return steueranteileData;
      }
      return steueranteileData; // ToDo :: remove

    case DataCode.nominalNachSteuern:
      switch (dataset.code) {
        case '20':
          return nominalNachSteuernData20;
        case '10':
          return nominalNachSteuernData10;
        case '5':
          return nominalNachSteuernData5;
        case '1':
          return nominalNachSteuernData1;
        case '0.1':
          return nominalNachSteuernData;
      }
      return nominalNachSteuernData; // ToDo :: remove
    case DataCode.nominalVorSteuern:
      switch (dataset.code) {
        case '20':
          return nominalVorSteuernData20;
        case '10':
          return nominalVorSteuernData10;
        case '5':
          return nominalVorSteuernData5;
        case '1':
          return nominalVorSteuernData1;
        case '0.1':
          return nominalVorSteuernData;
      }
      return nominalVorSteuernData; // ToDo :: remove
    case DataCode.realNachSteuern:
      switch (dataset.code) {
        case '20':
          return realNachSteuernData20;
        case '10':
          return realNachSteuernData10;
        case '5':
          return realNachSteuernData5;
        case '1':
          return realNachSteuernData1;
        case '0.1':
          return realNachSteuernData;
      }
      return realNachSteuernData; // ToDo :: remove
    case DataCode.realVorSteuern:
      switch (dataset.code) {
        case '20':
          return realVorSteuernData20;
        case '10':
          return realVorSteuernData10;
        case '5':
          return realVorSteuernData5;
        case '1':
          return realVorSteuernData1;
        case '0.1':
          return realVorSteuernData;
      }
      return realVorSteuernData; // ToDo :: remove
    case DataCode.anteilSteuernuller:
      return anteilSteuernullerKantone;
  }
};

const getLocalizations = (dataset: Dataset, dataCode: DataCode) => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return null;
  }

  return getLocalizationsForData(data);
};

// TODO: Verify that localizations the same for all datafiles and refactor this
const getLocalizationsForData = (dataFile: DataFile) => {
  let result: Array<Localization> = [];
  const data = dataFile;

  if (!data) {
    return null;
  }

  data.columns.forEach((column, index) => {
    if (column !== '') {
      if (column === 'CH') {
        result.unshift({
          index,
          code: column,
          name: data.column_labels[index],
        });
      } else {
        result.push({
          index,
          code: column,
          name: data.column_labels[index],
        });
      }
    }
  });

  return result;
};

const getYearRangeData = (dataset: Dataset, dataCode: DataCode, startYear: number, endYear: number) => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return null;
  }

  return getDataForYearRange(data, startYear, endYear);
};

const getDataForYearRange = (data: DataFile, startYear: number, endYear: number) => {
  const yearsData = data.data.filter((d) => d.year >= startYear && d.year <= endYear);
  if (!yearsData || yearsData.length === 0) {
    return null;
  }

  return yearsData;
};

const getDataYears = (dataset: Dataset, dataCode: DataCode): Array<number> | null => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return null;
  }

  return data.data.map((item) => item.year);
};

const getYearData = (dataset: Dataset, dataCode: DataCode, year: number): Array<number | null> | null => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return null;
  }

  return getDataForYear(data, year);
};

const getDataForYear = (data: DataFile, year: number): Array<number | null> | null => {
  const yearData = data.data.filter((d) => d.year === year);
  if (!yearData || yearData.length === 0) {
    return null;
  }
  return yearData[0].data;
};

const getMinYear = (dataset: Dataset, dataCode: DataCode) => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return new Date().getFullYear();
  }

  return getMinYearForData(data);
};

const getMinYearForData = (data: DataFile) => {
  let result = new Date().getFullYear();

  data.data.forEach((d) => {
    if (d.year) {
      result = Math.min(d.year, result);
    }
  });

  return result;
};

const getMaxYear = (dataset: Dataset, dataCode: DataCode) => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return 0;
  }

  return getMaxYearForData(data);
};

const getMaxYearForData = (data: DataFile) => {
  let result = 0;

  data.data.forEach((d) => {
    if (d.year) {
      result = Math.max(d.year, result);
    }
  });

  return result;
};

const getAvailableYear = (dataset: Dataset, dataCode: DataCode, year: number): number => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return year;
  }

  return getNextYearWithData(data, year);
};

const getNextYearWithData = (data: DataFile, year: number): number => {
  if (data.data.find((d) => d.year === year)) {
    return year;
  }

  let result = data.data.find((d) => d.year > year);
  if (result) {
    return result.year;
  }

  result = data.data.find((d) => d.year < year);
  if (result) {
    return result.year;
  }

  return year;
};

const getAvailableYearLocal = (dataset: Dataset, dataCode: DataCode, year: number, localization: string): number => {
  const data = getData(dataset, dataCode);
  if (!data) {
    return year;
  }

  return getNextYearWithDataForLocalization(data, year, localization);
};

const getNextYearWithDataForLocalization = (data: DataFile, year: number, localization: string): number => {
  const localIndex = data.columns.findIndex((c) => c.toLocaleLowerCase() === localization.toLocaleLowerCase());
  let yearData = data.data.find((d) => d.year === year && d.data[localIndex] != null);

  if (yearData) {
    return year;
  }

  yearData = data.data.find((d) => d.year > year && d.data[localIndex] != null);
  if (yearData) {
    return yearData.year;
  }

  yearData = data.data.find((d) => d.year < year && d.data[localIndex] != null);
  if (yearData) {
    return yearData.year;
  }

  return year;
};

const getMaxValue = (dataCode: DataCode, dataSet: Dataset) => {
  const data = getData(dataSet, dataCode);
  if (!data) {
    return 0;
  }

  let maxValue = 0;

  data.data.forEach((d) => {
    d.data.forEach((e) => {
      if (e && maxValue < e) {
        maxValue = e;
      }
    });
  });

  return maxValue;
};

export const ChartDatasetContext = React.createContext({ allData: { nodes: [] as Array<any> }, dataset: getDatasets()[0] });

export default {
  getDataCodeName,
  getDatasets,
  getLocalizations,
  getLocalizationsForData,
  getYearData,
  getDataForYear,
  getYearRangeData,
  getDataForYearRange,
  getMinYear,
  getMinYearForData,
  getMaxYear,
  getMaxYearForData,
  getDataYears,
  getAvailableYear,
  getNextYearWithData,
  getAvailableYearLocal,
  getNextYearWithDataForLocalization,
  stringFormat,
  getColor,
  getMaxValue,
};
